export default __webpack_public_path__ + "static/media/human.7222b252.svg";